import axios from "axios";

import { IP } from "../utils/Host";

export function skasujGrupe(
  global_id_grupa,
  fechparametryTechnologii,
  zamowienie_id,
  technologia_id,
  grupaId
) {
  axios
    .get(
      IP +
        "skasujGrupe/" +
        global_id_grupa +
        "/" +
               grupaId +
        "/" +
               technologia_id +
        "/" +
        sessionStorage.getItem("token"),
    )
    .then((res) => {
      fechparametryTechnologii(zamowienie_id, technologia_id);
    });
}
